<template>
  <div
    class="user-avatar-dropdown"
    @mouseenter="openMenu"
    @mouseleave="scheduleCloseMenu"
  >
    <Dropdown
      trigger="custom"
      :visible="menuVisible"
      :transfer="false"
      placement="bottom-end"
      @on-clickoutside="closeMenu"
      @on-click="handleClick"
    >
      <a
        class="user-trigger"
        href="javascript:void(0)"
        role="button"
        aria-haspopup="true"
        :aria-expanded="String(menuVisible)"
        aria-label="账号菜单"
        @click.prevent.stop="toggleMenu"
        @keydown.enter.prevent="toggleMenu"
        @keydown.space.prevent="toggleMenu"
      >
        <Avatar v-if="avatarSrc" class="user-trigger__avatar" :src="avatarSrc" :size="24" />
        <Avatar v-else class="user-trigger__avatar" :size="24">{{ avatarText }}</Avatar>
        <span class="user-trigger__name">{{ displayName }}</span>
        <Icon class="user-trigger__arrow" type="ios-arrow-down" :size="14" />
      </a>
      <DropdownMenu slot="list" class="user-menu">
        <div class="user-menu__profile" @click.stop>
          <div class="user-menu__heading">
            <div class="user-menu__name">{{ displayName }}</div>
            <Tag v-if="roleLabel" color="primary" class="user-menu__role">{{ roleLabel }}</Tag>
          </div>
          <div v-if="profileLines.length" class="user-menu__meta">
            <div v-for="line in profileLines" :key="line.key" class="user-menu__meta-item">
              <div class="user-menu__meta-label">{{ line.label }}</div>
              <div class="user-menu__meta-value">{{ line.value }}</div>
            </div>
          </div>
        </div>
        <DropdownItem name="logout" divided>退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
  import './user.less'
  import { mapActions } from 'vuex'

  export default {
    name: 'User',
    props: {
      userAvatar: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        menuVisible: false,
        closeTimer: null,
      }
    },
    computed: {
      /**
       * 登录接口写入 localStorage 的用户信息
       * @returns {Record<string, *>}
       */
      userInfo() {
        try {
          const raw = localStorage.getItem('userInfo')
          return raw ? JSON.parse(raw) : {}
        } catch (e) {
          return {}
        }
      },
      /** 页头展示名称 */
      displayName() {
        const name = this.userInfo.name
        if (name) {
          return name
        }
        return this.userInfo.email || '管理员'
      },
      /** 头像地址：接口 avatar 优先，其次父组件传入 */
      avatarSrc() {
        return this.userInfo.avatar || this.userAvatar || ''
      },
      /** 无图时用名称首字 */
      avatarText() {
        const name = String(this.displayName || '')
        return name ? name.slice(0, 1) : '管'
      },
      /**
       * 下拉中按接口字段酌情展示的资料行
       * @returns {Array<{ key: string, label: string, value: string }>}
       */
      profileLines() {
        const info = this.userInfo
        const lines = []
        if (info.email) {
          lines.push({ key: 'email', label: '邮箱', value: String(info.email) })
        }
        if (info.mobile) {
          lines.push({ key: 'mobile', label: '手机', value: String(info.mobile) })
        }
        return lines
      },
      /** 超级管理员标识（有值才显示） */
      roleLabel() {
        if (String(this.userInfo.is_super) === '1') {
          return '超级管理员'
        }
        return ''
      },
    },
    beforeDestroy() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    methods: {
      ...mapActions(['handleLogOut']),
      /** 打开菜单（悬停） */
      openMenu() {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer)
          this.closeTimer = null
        }
        this.menuVisible = true
      },
      /** 延迟关闭，便于移入菜单 */
      scheduleCloseMenu() {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer)
        }
        this.closeTimer = setTimeout(() => {
          this.menuVisible = false
          this.closeTimer = null
        }, 150)
      },
      /** 点击切换 */
      toggleMenu() {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer)
          this.closeTimer = null
        }
        this.menuVisible = !this.menuVisible
      },
      /** 关闭菜单 */
      closeMenu() {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer)
          this.closeTimer = null
        }
        this.menuVisible = false
      },
      logout() {
        this.handleLogOut().then(() => {
          this.$router.push({
            name: 'login',
          })
        })
      },
      /**
       * @param {string} name
       */
      handleClick(name) {
        switch (name) {
          case 'logout':
            this.closeMenu()
            this.logout()
            break
        }
      },
    },
  }
</script>
